var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundIconFour({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 53,
    viewBox: "0 0 62 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.875 8.16609C30.875 8.16609 16.4375 -4.20891 2 6.10359V51.4786C16.4375 41.1661 30.875 51.4786 30.875 51.4786M30.875 8.16609C30.875 8.16609 45.3125 -4.20891 59.75 6.10359V51.4786C45.3125 41.1661 30.875 51.4786 30.875 51.4786M30.875 8.16609V51.4786",
    stroke: "#F8C8CF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundIconFour);
export default __webpack_public_path__ + "static/media/background_icon_four.ec9a90931562b1123dfb8da1646d9d2e.svg";
export { ForwardRef as ReactComponent };